// Types d'activités pour le système de traçabilité

export const ACTIVITY_TYPES = {
  // Utilisateurs
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
  USER_CREATED: 'user_created',
  USER_UPDATED: 'user_updated',
  USER_DELETED: 'user_deleted',
  USER_PASSWORD_CHANGED: 'user_password_changed',
  USER_STATUS_CHANGED: 'user_status_changed',
  
  // Abonnés
  SUBSCRIBER_CREATED: 'subscriber_created',
  SUBSCRIBER_UPDATED: 'subscriber_updated',
  SUBSCRIBER_DELETED: 'subscriber_deleted',
  SUBSCRIBER_STATUS_CHANGED: 'subscriber_status_changed',
  SUBSCRIBER_CAUTION_PAID: 'subscriber_caution_paid',
  
  // Compteurs
  METER_CREATED: 'meter_created',
  METER_UPDATED: 'meter_updated',
  METER_DELETED: 'meter_deleted',
  METER_STATUS_CHANGED: 'meter_status_changed',
  METER_REPLACED: 'meter_replaced',
  
  // Relevés
  READING_CREATED: 'reading_created',
  READING_UPDATED: 'reading_updated',
  READING_DELETED: 'reading_deleted',
  READING_CORRECTED: 'reading_corrected',
  
  // Factures
  BILL_CREATED: 'bill_created',
  BILL_UPDATED: 'bill_updated',
  BILL_DELETED: 'bill_deleted',
  BILL_ISSUED: 'bill_issued',
  BILL_CANCELLED: 'bill_cancelled',
  
  // Paiements
  PAYMENT_CREATED: 'payment_created',
  PAYMENT_UPDATED: 'payment_updated',
  PAYMENT_DELETED: 'payment_deleted',
  PAYMENT_COMPLETED: 'payment_completed',
  PAYMENT_FAILED: 'payment_failed',
  
  // Autres
  REPORT_GENERATED: 'report_generated',
  DOCUMENT_EXPORTED: 'document_exported',
  SETTINGS_CHANGED: 'settings_changed'
};

export const ACTIVITY_LABELS = {
  user_login: 'Connexion utilisateur',
  user_logout: 'Déconnexion utilisateur',
  user_created: 'Utilisateur créé',
  user_updated: 'Utilisateur modifié',
  user_deleted: 'Utilisateur supprimé',
  user_password_changed: 'Mot de passe changé',
  user_status_changed: 'Statut utilisateur changé',
  
  subscriber_created: 'Abonné créé',
  subscriber_updated: 'Abonné modifié',
  subscriber_deleted: 'Abonné supprimé',
  subscriber_status_changed: 'Statut abonné changé',
  subscriber_caution_paid: 'Caution payée',
  
  meter_created: 'Compteur créé',
  meter_updated: 'Compteur modifié',
  meter_deleted: 'Compteur supprimé',
  meter_status_changed: 'Statut compteur changé',
  meter_replaced: 'Compteur remplacé',
  
  reading_created: 'Relevé créé',
  reading_updated: 'Relevé modifié',
  reading_deleted: 'Relevé supprimé',
  reading_corrected: 'Relevé corrigé',
  
  bill_created: 'Facture créée',
  bill_updated: 'Facture modifiée',
  bill_deleted: 'Facture supprimée',
  bill_issued: 'Facture émise',
  bill_cancelled: 'Facture annulée',
  
  payment_created: 'Paiement créé',
  payment_updated: 'Paiement modifié',
  payment_deleted: 'Paiement supprimé',
  payment_completed: 'Paiement complété',
  payment_failed: 'Paiement échoué',
  
  report_generated: 'Rapport généré',
  document_exported: 'Document exporté',
  settings_changed: 'Paramètres changés'
};

export const ACTIVITY_CATEGORIES = {
  USER: 'user',
  SUBSCRIBER: 'subscriber',
  METER: 'meter',
  READING: 'reading',
  BILLING: 'billing',
  PAYMENT: 'payment',
  REPORT: 'report',
  SYSTEM: 'system'
};

export const getActivityCategory = (activityType) => {
  const categoryMap = {
    // Users
    [ACTIVITY_TYPES.USER_LOGIN]: ACTIVITY_CATEGORIES.USER,
    [ACTIVITY_TYPES.USER_LOGOUT]: ACTIVITY_CATEGORIES.USER,
    [ACTIVITY_TYPES.USER_CREATED]: ACTIVITY_CATEGORIES.USER,
    [ACTIVITY_TYPES.USER_UPDATED]: ACTIVITY_CATEGORIES.USER,
    [ACTIVITY_TYPES.USER_DELETED]: ACTIVITY_CATEGORIES.USER,
    [ACTIVITY_TYPES.USER_PASSWORD_CHANGED]: ACTIVITY_CATEGORIES.USER,
    [ACTIVITY_TYPES.USER_STATUS_CHANGED]: ACTIVITY_CATEGORIES.USER,
    
    // Subscribers
    [ACTIVITY_TYPES.SUBSCRIBER_CREATED]: ACTIVITY_CATEGORIES.SUBSCRIBER,
    [ACTIVITY_TYPES.SUBSCRIBER_UPDATED]: ACTIVITY_CATEGORIES.SUBSCRIBER,
    [ACTIVITY_TYPES.SUBSCRIBER_DELETED]: ACTIVITY_CATEGORIES.SUBSCRIBER,
    [ACTIVITY_TYPES.SUBSCRIBER_STATUS_CHANGED]: ACTIVITY_CATEGORIES.SUBSCRIBER,
    [ACTIVITY_TYPES.SUBSCRIBER_CAUTION_PAID]: ACTIVITY_CATEGORIES.SUBSCRIBER,
    
    // Meters
    [ACTIVITY_TYPES.METER_CREATED]: ACTIVITY_CATEGORIES.METER,
    [ACTIVITY_TYPES.METER_UPDATED]: ACTIVITY_CATEGORIES.METER,
    [ACTIVITY_TYPES.METER_DELETED]: ACTIVITY_CATEGORIES.METER,
    [ACTIVITY_TYPES.METER_STATUS_CHANGED]: ACTIVITY_CATEGORIES.METER,
    [ACTIVITY_TYPES.METER_REPLACED]: ACTIVITY_CATEGORIES.METER,
    
    // Readings
    [ACTIVITY_TYPES.READING_CREATED]: ACTIVITY_CATEGORIES.READING,
    [ACTIVITY_TYPES.READING_UPDATED]: ACTIVITY_CATEGORIES.READING,
    [ACTIVITY_TYPES.READING_DELETED]: ACTIVITY_CATEGORIES.READING,
    [ACTIVITY_TYPES.READING_CORRECTED]: ACTIVITY_CATEGORIES.READING,
    
    // Billing
    [ACTIVITY_TYPES.BILL_CREATED]: ACTIVITY_CATEGORIES.BILLING,
    [ACTIVITY_TYPES.BILL_UPDATED]: ACTIVITY_CATEGORIES.BILLING,
    [ACTIVITY_TYPES.BILL_DELETED]: ACTIVITY_CATEGORIES.BILLING,
    [ACTIVITY_TYPES.BILL_ISSUED]: ACTIVITY_CATEGORIES.BILLING,
    [ACTIVITY_TYPES.BILL_CANCELLED]: ACTIVITY_CATEGORIES.BILLING,
    
    // Payments
    [ACTIVITY_TYPES.PAYMENT_CREATED]: ACTIVITY_CATEGORIES.PAYMENT,
    [ACTIVITY_TYPES.PAYMENT_UPDATED]: ACTIVITY_CATEGORIES.PAYMENT,
    [ACTIVITY_TYPES.PAYMENT_DELETED]: ACTIVITY_CATEGORIES.PAYMENT,
    [ACTIVITY_TYPES.PAYMENT_COMPLETED]: ACTIVITY_CATEGORIES.PAYMENT,
    [ACTIVITY_TYPES.PAYMENT_FAILED]: ACTIVITY_CATEGORIES.PAYMENT,
    
    // Reports
    [ACTIVITY_TYPES.REPORT_GENERATED]: ACTIVITY_CATEGORIES.REPORT,
    [ACTIVITY_TYPES.DOCUMENT_EXPORTED]: ACTIVITY_CATEGORIES.REPORT,
    
    // System
    [ACTIVITY_TYPES.SETTINGS_CHANGED]: ACTIVITY_CATEGORIES.SYSTEM
  };
  
  return categoryMap[activityType] || ACTIVITY_CATEGORIES.SYSTEM;
};
